// What a session's browser string says about the device, in the words a
// person uses: which browser, on which system. Only the few names a session
// list needs; anything else is null, and the page says it does not know.
//
// The order matters: most browsers claim to be several others. Edge and Opera
// say Chrome, and Chrome says Safari, so each is asked for before what it
// imitates. The iPhone app's web view names no browser at all.

const BROWSERS = [
    ['Edge', /\bEdg(e|A|iOS)?\//],
    ['Opera', /\b(OPR|Opera)\//],
    ['Samsung Internet', /\bSamsungBrowser\//],
    ['Firefox', /\b(Firefox|FxiOS)\//],
    ['Chrome', /\b(Chrome|CriOS)\//],
    ['Safari', /\bVersion\/[\d.]+.*\bSafari\//]
];

const SYSTEMS = [
    ['iPhone', /\biPhone\b/],
    ['iPad', /\biPad\b/],
    ['Android', /\bAndroid\b/],
    ['ChromeOS', /\bCrOS\b/],
    ['Windows', /\bWindows\b/],
    ['macOS', /\bMac OS X\b/],
    ['Linux', /\bLinux\b/]
];

function firstMatch(table, userAgent) {
    return table.find(([, pattern]) => pattern.test(userAgent))?.[0] ?? null;
}

/** `{ browser, system }`, each a name or null. */
export function describeDevice(userAgent) {
    if (typeof userAgent !== 'string' || userAgent.length === 0) {
        return { browser: null, system: null };
    }
    return { browser: firstMatch(BROWSERS, userAgent), system: firstMatch(SYSTEMS, userAgent) };
}
